export default __webpack_public_path__ + "static/media/bh2.d77eef1d.jpg";